import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {environment} from "../../../environments/environment";

@Component({
  selector: 'cintas-cabinet-stat-component',
  templateUrl: './cabinet-stat-component.component.html',
  styleUrls: ['./cabinet-stat-component.component.scss']
})
export class CabinetStatComponentComponent implements OnInit {

  @Input() title: string;
  @Input() items: any[];
  @Input() chartInfo: string;
  

  colorScheme = environment.theme.colorPalette;


  

  showLegend = true;

  // pie
  showLabels = true;
  explodeSlices = false;
  doughnut = false;


  constructor() { }

  ngOnInit() {
    console.log(this.items)
   }

  onSelect(event) {
    console.log(event);
  }


}
